<span class="file-upload">
    <button mat-raised-button (click)="fileUpload.click()" type="button" color="primary" [disabled]="isDisabledFlag">{{buttonText}}</button>
    <span *ngIf="file?.name" class="file-upload-padding">{{file.name}}</span>
    <span *ngIf="!file?.name"  class="file-upload-padding">{{tempFilename}}</span>
    <input type="file" hidden #fileUpload [accept]="fileType">
</span>
